 function checkMobile(sMobile){
       if(!(/^1[3-9]\d{9}$/.test(sMobile))){
        return false;
       }
       return true;
}

export {checkMobile}



// WEBPACK FOOTER //
// ./src/utils.js